export default "__VITE_ASSET__80381791__"